import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  FilteringState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  PagingState,
  SortingState
} from "@devexpress/dx-react-grid";
import {
  Grid,
  PagingPanel,
  Table,
  TableFilterRow,
  TableHeaderRow,
  Toolbar
} from "@devexpress/dx-react-grid-bootstrap3";

const LoadingState = ({ columnCount, loading }) => (
  <td
    colSpan={columnCount}
    style={{
      padding: "50px 0px"
    }}
  >
    <div
      style={{
        display: "inline-block",
        position: "fixed",
        left: "50%"
      }}
    >
      <big>
        {loading ? (
          <CircularProgress size={28} />
        ) : (
          <span>条件に一致したデータが見つかりません。</span>
        )}
      </big>
    </div>
  </td>
);

export default function CustomMaterialTable(props) {
  const { columns, data, tableSorting, tableColumnExtensions } = props;

  const pageSize = 50;

  return (
    <>
      <div>
        <Grid rows={data} columns={columns}>
          <FilteringState />
          <SortingState defaultSorting={tableSorting} />

          <PagingState pageSize={pageSize} />

          <IntegratedFiltering />
          <IntegratedSorting />
          <IntegratedPaging />

          <Table
            columnExtensions={tableColumnExtensions}
            noDataCellComponent={() => (
              <LoadingState
                columnCount={columns.length}
                loading={!data.length}
              />
            )}
          />

          <TableHeaderRow showSortingControls={true} />
          <TableFilterRow showFilterSelector={true} />
          <PagingPanel />

          <Toolbar />
        </Grid>
      </div>
    </>
  );
}
